import { t as e } from "../../chunks/cn.CW-jpn-X.js";
import { FileTypeCornerIcon as t, XIcon as n } from "lucide-react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { Transforms as a } from "slate";
// lib/PrintText/components/index.tsx
var o = ({ children: o, editor: s, element: c }) => {
	let l = !!s && !!c && s.children[0]?.id === c.id;
	return /* @__PURE__ */ i("div", {
		className: e("border rounded", !l && "mt-3"),
		children: [/* @__PURE__ */ i("div", {
			contentEditable: !1,
			draggable: !0,
			className: "flex items-center justify-between bg-slate-300 dark:bg-slate-900 p-2 cursor-grab",
			children: [/* @__PURE__ */ i("div", {
				className: "flex items-end gap-2",
				children: [/* @__PURE__ */ r(t, { size: 15 }), /* @__PURE__ */ r("span", {
					className: "text-xs font-semibold",
					children: "Print-text"
				})]
			}), /* @__PURE__ */ r("div", {
				className: "hover:cursor-pointer hover:bg-slate-200 dark:hover:bg-gray-700 p-1 -my-1 rounded",
				onMouseDown: (e) => {
					e.preventDefault(), e.stopPropagation();
					let t = s.children.findIndex((e) => e.id === c.id);
					t > -1 && a.removeNodes(s, { at: [t] });
				},
				children: /* @__PURE__ */ r(n, { size: 15 })
			})]
		}), /* @__PURE__ */ r("div", {
			className: "px-2",
			children: o
		})]
	});
};
export { o as PrintText };
